import { LegalLayout } from '../components/LegalLayout';

export const InformedConsent = () => {
    return (
        <LegalLayout title="Informed Medical Consent" lastUpdated="December 28, 2025">
            <p className="intro-text">
                This Informed Consent document explains the nature, purpose, benefits, and risks of participating in the Nostavia Health wellness program. Please read it carefully before proceeding.
            </p>

            <section>
                <h2>1. Nature of the Program</h2>
                <p>
                    Nostavia Health offers a wellness program focused on optimizing your long-term health and vitality. This involves the analysis of various biomarkers (from blood tests or other sources) and lifestyle data to generate a biological age estimate and personalized recommendations for diet, exercise, sleep, and supplementation.
                </p>
            </section>

            <section>
                <h2>2. NOT MEDICAL CARE</h2>
                <div style={{ backgroundColor: '#fff3cd', color: '#856404', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem', border: '1px solid #ffeeba' }}>
                    <strong>CRITICAL: NO DOCTOR-PATIENT RELATIONSHIP</strong>
                </div>
                <p>
                    You understand and agree that Nostavia Health is NOT a medical provider. Our Services, including any reports or consultations, do NOT constitute medical advice, diagnosis, or treatment. No doctor-patient relationship is created between you and Nostavia Health or any of its employees.
                </p>
                <p>
                    We do not treat, cure, or prevent any specific disease or medical condition. If you have a medical emergency, call emergency services immediately. If you have specific health concerns or symptoms, you must consult with your primary care physician or a relevant specialist.
                </p>
            </section>

            <section>
                <h2>3. Voluntary Participation</h2>
                <p>
                    Your participation in this program is completely voluntary. You have the right to decline any recommendation or to withdraw from the program at any time by cancelling your membership in accordance with our Terms of Service.
                </p>
            </section>

            <section>
                <h2>4. Potential Risks</h2>
                <p>While we strive to provide safe and evidence-based recommendations, there are potential risks associated with any wellness program:</p>
                <ul>
                    <li><strong>Blood Collection:</strong> If you undergo blood testing, there are minor risks associated with phlebotomy, including temporary pain, bruising, dizziness, or rarely, infection.</li>
                    <li><strong>Lifestyle Changes:</strong> Changes to diet, exercise, or supplementation can cause physical discomfort or adverse reactions. You should consult your physician before starting any new exercise or supplement regimen, especially if you have pre-existing conditions or take medication.</li>
                    <li><strong>Emotional Impact:</strong> Learning about your biological age or potential health risks may cause anxiety or distress.</li>
                </ul>
            </section>

            <section>
                <h2>5. Privacy and Data Usage</h2>
                <p>
                    We value your privacy. Your health data constitutes Protected Health Information (PHI) to the extent applicable laws apply. We use your data to generate your insights and improve our models. Please refer to our <a href="/privacy">Privacy Policy</a> and <a href="/practices">Notice of Privacy Practices</a> for detailed information on how we protect your data.
                </p>
            </section>

            <section>
                <h2>6. Acknowledgment and Consent</h2>
                <p>
                    By clicking "I Agree" or by using the Services, you acknowledge that:
                </p>
                <ul>
                    <li>You have read and understood this Informed Consent document.</li>
                    <li>You understand that Nostavia Health is not providing medical care.</li>
                    <li>You have had the opportunity to ask questions (via our support channels).</li>
                    <li>You voluntarily agree to participate in the program.</li>
                </ul>
            </section>
        </LegalLayout>
    );
};
